import { applyInlineStyles } from '../../../utils/dom-style'
import { type EmbedIFrameComponent } from '../../embed-component'
import { type EmbedTarget } from '../../embed-targets'
import { type EmbedStyleControl, DefaultEmbedStyleControl } from '../../iframe/default-embed-style-control'
import { type EmbedCSSStyles } from '../../style'
import { type IFrameEmbedHandler } from './IFrameEmbedStrategy'

export abstract class ParentStrategyHandler implements IFrameEmbedHandler {
  iframeControl: EmbedStyleControl
  iFrameComponent: EmbedIFrameComponent

  constructor (
    public readonly embedTarget: EmbedTarget
  ) {
  }

  /**
   * A wrapper element of the embedding content.
   * A wrapper styles will be applied to this element.
   */
  abstract get wrapperEl (): HTMLElement | null

  /**
   * Define how to append an iframe element to the DOM.
   * @param el
   */
  abstract appendEmbedComponentTo (el: HTMLElement): void

  async initIFrame (iFrameComponent: EmbedIFrameComponent) {
    this.iframeControl = new DefaultEmbedStyleControl(this.embedTarget, iFrameComponent.rootEl)
    this.iFrameComponent = iFrameComponent
    const wrapperStyle: EmbedCSSStyles = {
      position: 'relative'
    }
      ; (this.wrapperEl != null) && applyInlineStyles(wrapperStyle, this.wrapperEl)
    this.appendEmbedComponentTo(this.iFrameComponent.rootEl)
  }

  async onTeleportUpdate () {
    this.iframeControl.updateStyle(
      this.embedTarget.ctx.teleportActive === true ? 'teleport' : 'overlay'
    )
  }

  show (): void {
    this.wrapperEl?.style.setProperty('display', '')
  }

  hide (): void {
    this.wrapperEl?.style.setProperty('display', 'none')
  }
}

export class DefaultParentStrategyHandler extends ParentStrategyHandler {
  get wrapperEl (): HTMLElement | null {
    return this.embedTarget.ctx.targetEl.parentElement
  }

  appendEmbedComponentTo (el: HTMLElement): void {
    this.embedTarget.ctx.targetEl.after(el)
  }
}

export class TargetAsParentStrategyHandler extends ParentStrategyHandler {
  get wrapperEl (): HTMLElement | null {
    return this.embedTarget.ctx.targetEl
  }

  appendEmbedComponentTo (el: HTMLElement): void {
    this.embedTarget.ctx.targetEl.appendChild(el)
  }
}
